export function normalizeCode(code) {
  return String(code).trim().toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 5);
}

// A seat's name is painted on a TV seat card, a phone header, a target button and the
// banner every card play throws up. Uncapped, one "Maximiliana Wennerström-Gyllenhammar"
// wrapped to three lines on her own phone and pushed the mana counter off its row.
export const NAME_MAX_LENGTH = 20;

export function normalizeName(name) {
  return String(name ?? "").trim().slice(0, NAME_MAX_LENGTH).trim();
}

export function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function makeId() {
  const cryptoApi = window.crypto || window.msCrypto;
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  if (cryptoApi?.getRandomValues) {
    const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    return [...bytes].map((byte, index) => {
      const value = byte.toString(16).padStart(2, "0");
      return [4, 6, 8, 10].includes(index) ? `-${value}` : value;
    }).join("");
  }
  return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
